import React from 'react';

/**
 * Applies light/dark theme to widget preview via data-theme + CSS variables.
 */
export default function ThemeProvider({ theme = 'dark', primaryColor, children }) {
  const style = primaryColor
    ? { '--sw-accent': `#${primaryColor.replace('#', '')}` }
    : undefined;

  return (
    <div
      className="sw-widget-root w-full min-w-0 block rounded-xl overflow-hidden"
      data-theme={theme}
      style={style}
    >
      {children}
    </div>
  );
}
